import React, { useContext, useEffect, useState } from "react";
import { AuthRoutes, NonAuthRoutes } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import ATextField from "../../components/ATextField";
import { Icon, PrimaryButton } from "@fluentui/react";
import { AuthenticateOTPSchema } from "../../Schemas/LoginSchema";
import { encryptData } from "../../helpers/RSAUtility";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { generateOTP2FA } from "../../service/UserService";
import VDC_AIPoweredCloudPacs from "../../components/SVGComponents/Logo/VDC_AIPoweredCloudPacs";
import userContext from "../../context/users/UserContext";
import { useLocation } from "react-router-dom";
import { getEnv } from '../../helpers/EnvHelper';
 
 const textFieldStyles = {
  errorMessage: {
    color: "#ff0000",
    fontWeight: "700",
    fontSize: "12px",
  },
  fieldGroup: {
    borderRadius: "7px",
  },
  field: {
    ":focus": {
      borderRadius: "7px",
    },
  },
  root: {
    color: "rgb(255,255,255) !important",
    border: "none !important",
  },
};
const TwoFAOtp = () => {

  const { authenticate2FAOTP } = useContext(userContext);

  const [email, setEmail] = useState(
    localStorage.getItem("2faEmail")
  );
  const [username, setUsername] = useState(
    localStorage.getItem("2faUsername")
  );
    // NEW: store which channels were used and the masked contacts for 2FA
  const [otpSentInfo, setOtpSentInfo] = useState({
    emailSent: false,
    whatsappSent: false,
    email: localStorage.getItem("2faEmail") || null,
    whatsappNumber: localStorage.getItem("2faWhatsApp") || null
  });

  const [otp] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [t] = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [resendEnablingTime, setResendEnablingTime] = useState(180);
  const [showDeactivateUserError, setShowDeactivateUserError] = useState(false);
  const [isUserLocked , setUserLocked] = useState(false);

  
 const parseStoredBool = (val) => {
    if (val === null || val === undefined) return false;
    return val === "true" || val === true;
  };
  // useEffect(() => {
  //   const TwoFAUserName = localStorage.getItem(
  //     "2faUsername"
  //   );
    
  //   setEmail(localStorage.getItem("2faEmail"));

  //   if (TwoFAUserName && TwoFAUserName != null) {
  //     setUsername(TwoFAUserName);
  //   } else {
  //     navigate(NonAuthRoutes.LOGIN);
  //   }
  // }, []);
   // add at top: import { useLocation } from "react-router-dom";
// inside component:

useEffect(() => {
  const TwoFAUserName = localStorage.getItem("2faUsername");
  const navData = location && location.state ? location.state.otpResponse || location.state : null;

  // Helper to convert stored string booleans
  const parseStoredBool = (val) => val === "true" || val === true;

  // If server DTO was passed, prefer it and persist/clear storage accordingly
  if (navData && (typeof navData.emailSent !== "undefined" || typeof navData.whatsappSent !== "undefined" || navData.email || navData.whatsappNumber)) {
    const dto = navData;

    // EMAIL handling
    if (typeof dto.emailSent !== "undefined") {
      if (dto.emailSent && dto.email) {
        localStorage.setItem("2faEmail", dto.email);
        localStorage.setItem("2faEmailSent", dto.emailSent.toString());
      } else {
        localStorage.removeItem("2faEmail");
        localStorage.removeItem("2faEmailSent");
      }
    } else if (dto.email) {
      localStorage.setItem("2faEmail", dto.email);
    }

    // WHATSAPP handling (important: clear stored number if server says whatsappSent=false)
    if (typeof dto.whatsappSent !== "undefined") {
      if (dto.whatsappSent && dto.whatsappNumber) {
        localStorage.setItem("2faWhatsApp", dto.whatsappNumber);
        localStorage.setItem("2faWhatsappSent", dto.whatsappSent.toString());
      } else {
        // server explicitly said false → clear stale stored number so UI won't show it
        localStorage.removeItem("2faWhatsApp");
        localStorage.removeItem("2faWhatsappSent");
      }
    } else if (dto.whatsappNumber) {
      localStorage.setItem("2faWhatsApp", dto.whatsappNumber);
    }

    // initialize state from DTO (prefer explicit flags)
    setOtpSentInfo({
      emailSent: typeof dto.emailSent !== "undefined" ? !!dto.emailSent : !!dto.email,
      whatsappSent: typeof dto.whatsappSent !== "undefined" ? !!dto.whatsappSent : !!dto.whatsappNumber,
      email: dto.email || localStorage.getItem("2faEmail"),
      whatsappNumber: dto.whatsappNumber || localStorage.getItem("2faWhatsApp"),
    });

    // ensure username present
    setUsername(localStorage.getItem("2faUsername") || "");
    setEmail(localStorage.getItem("2faEmail") || null);
    return;
  }

  // fallback: read from localStorage but prefer explicit stored boolean flags
  if (TwoFAUserName && TwoFAUserName != null) {
    setUsername(TwoFAUserName);
    const emailStored = localStorage.getItem("2faEmail");
    const whatsappStored = localStorage.getItem("2faWhatsApp");
    const emailSentStored = localStorage.getItem("2faEmailSent");
    const whatsappSentStored = localStorage.getItem("2faWhatsappSent");

    const emailSent = parseStoredBool(emailSentStored);
    const whatsappSent = parseStoredBool(whatsappSentStored);

    setOtpSentInfo({
      emailSent: emailSent || (!!emailStored && emailSentStored === null),
      whatsappSent: whatsappSent || (!!whatsappStored && whatsappSentStored === null),
      email: emailStored || null,
      whatsappNumber: whatsappStored || null,
    });
    setEmail(emailStored || null);
  } else {
    navigate(NonAuthRoutes.LOGIN);
  }
}, [location]);


  // const handleResend = async () => {
  //   const encryptedUsername = encryptData(
  //     localStorage.getItem("2faUsername")
  //   );
  //   const response = await generateOTP2FA(encryptedUsername);
  //   if (response.status === 200) {
  //     localStorage.setItem("2faEmail", response.data.data.email);
  //     setResendEnablingTime(180);
  //     setIsResendEnabled(false);
  //   }
  // };
    const handleResend = async () => {
  const encryptedUsername = encryptData(localStorage.getItem("2faUsername"));
  const response = await generateOTP2FA(encryptedUsername);
  if (response && response.status === 200) {
    const data = (response.data && response.data.data) ? response.data.data : {};

    // EMAIL
    if (typeof data.emailSent !== "undefined") {
      if (data.emailSent && data.email) {
        localStorage.setItem("2faEmail", data.email);
        localStorage.setItem("2faEmailSent", data.emailSent.toString());
      } else {
        localStorage.removeItem("2faEmail");
        localStorage.removeItem("2faEmailSent");
      }
    } else if (data.email) {
      localStorage.setItem("2faEmail", data.email);
    }

    // WHATSAPP
    if (typeof data.whatsappSent !== "undefined") {
      if (data.whatsappSent && data.whatsappNumber) {
        localStorage.setItem("2faWhatsApp", data.whatsappNumber);
        localStorage.setItem("2faWhatsappSent", data.whatsappSent.toString());
      } else {
        localStorage.removeItem("2faWhatsApp");
        localStorage.removeItem("2faWhatsappSent");
      }
    } else if (data.whatsappNumber) {
      localStorage.setItem("2faWhatsApp", data.whatsappNumber);
    }

    setOtpSentInfo({
      emailSent: typeof data.emailSent !== "undefined" ? !!data.emailSent : !!data.email,
      whatsappSent: typeof data.whatsappSent !== "undefined" ? !!data.whatsappSent : !!data.whatsappNumber,
      email: data.email || localStorage.getItem("2faEmail"),
      whatsappNumber: data.whatsappNumber || localStorage.getItem("2faWhatsApp"),
    });

    setResendEnablingTime(180);
    setIsResendEnabled(false);
  }
};



  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        username,
        otp,
      },
      validationSchema: () => AuthenticateOTPSchema(t),
      onSubmit: async (values, action) => {
        const encryptedUsername = encryptData(values.username);
        const encryptedOTP = encryptData(values.otp);

        const response = await authenticate2FAOTP(encryptedUsername, encryptedOTP);

        const isForceReset =
          localStorage.getItem("forceReset") === "true" ||
          localStorage.getItem("redirectOnLogin") === "true"
            ? true
            : false;

        if (response.status === 200) {
          if (isForceReset) {
            navigate(AuthRoutes.FORCECHANGEPWD);
          } else {
            localStorage.removeItem("2faEmail");
            localStorage.removeItem("2faUsername");

            localStorage.removeItem("2faEmailSent");
            localStorage.removeItem("2faWhatsappSent");
            localStorage.removeItem("2faUsername");
            navigate(AuthRoutes.STUDYLIST);
          }
        } else {
          if(response.data.message.includes("No attempts remaining."))
          {
            setShowDeactivateUserError(true);
            setUserLocked(true);
          }else{
            setShowDeactivateUserError(false);
            setErrorMessage(response.data.message);
          }
            // navigate(NonAuthRoutes.LOGIN);
          
          setIsAuthenticated(false);
          if (
            !(
              response.data.message.includes("1") ||
              response.data.message.includes("2") ||
              response.data.message.includes("required")
            )
          ) {
            setResendEnablingTime(0);
            setIsResendEnabled(false);
          }
          // setErrorMessage(response.data.message);
        }

        action.resetForm();
      },
    });

  useEffect(() => {
    if (!isResendEnabled) {
      setTimeout(() => {
        if (resendEnablingTime === 0 && !isUserLocked) {
          setIsResendEnabled(true);
        } else {
          setResendEnablingTime(resendEnablingTime - 1);
        }
      }, 1000);
    }
  }, [resendEnablingTime, isResendEnabled]);

  const handleKeyPress = (e) => {
    if (e.which === 13) {
      handleSubmit();
    }
  };

  return (
    <>
      <div
        className="ms-Grid container"
        dir="ltr"
        style={{
          height: "100%",
          width: "100%",
          padding: "0px",
          overflowY: "hidden",
          backgroundColor: "white"
        }}
        onKeyDown={handleKeyPress}
      >
        <div className="ms-Grid-row" style={{ width: "100%", height: "100vh" }}>
          <div
            className="ms-Grid-col ms-xl6 ms-hiddenLgDown"
            style={{ padding: "0", height: "100%" }}
          >
            {getEnv("REACT_APP_VDC_PLATFORM") === "true" ? (
              <VDC_AIPoweredCloudPacs />
            ) : (
              <img
                className="ai-powered-cloud-image"
                src={`${window.location.origin}/images/AIPoweredCloudPacs.png`}
                alt="AI Powered Cloud Pacs"
              />
            )}
          </div>
          <div
            className="ms-Grid-col ms-sm12 ms-md10 ms-lg8 ms-xl4 ms-xlPush1 ms-lgPush2 ms-mdPush1"
            style={{ padding: "0" }}
          >
            <div className="login-form-container">
              <form>
                {/* <p
                  className="ms-fontSize-12 ms-fontWeight-semibold"
                  style={{
                    marginBottom: "20px",
                    lineHeight: "16px",
                  }}
                >
                  An OTP has been sent to your registered email id -{" "}
                  <span style={{ fontWeight: "bold" }}>{email}</span>
                  <br></br>
                  <br></br>
                  In case you do not see the email in your inbox, please check
                  your spam or junk mail folder before requesting for a new OTP.
                </p> */}
                                <div
                  className="ms-fontSize-12 ms-fontWeight-semibold"
                  style={{ marginBottom: "20px", lineHeight: "16px" }}
                >
                  {otpSentInfo.whatsappSent && (
                    <div style={{ marginTop: otpSentInfo.emailSent ? 8 : 0 }}>
                      An OTP has been sent to your registered WhatsApp number -{" "}
                      <span style={{ fontWeight: "bold" }}>{otpSentInfo.whatsappNumber}</span>
                    </div>
                  )}
                  {otpSentInfo.emailSent && (
                    <>
                      <div>
                        An OTP has been sent to your registered email id -{" "}
                        <span style={{ fontWeight: "bold" }}>{otpSentInfo.email}</span>
                      </div>
                      <div style={{ marginTop: "8px", marginBottom: "8px", fontSize: "13px" }}>
                        In case you do not see the email in your inbox, please check
                        your spam or junk mail folder before requesting for a new OTP.
                      </div>
                    </>
                  )}

                  

                  {!otpSentInfo.emailSent && !otpSentInfo.whatsappSent && (
                    <div>An OTP has been sent — please check your available channels.</div>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    margin: "30px 0 5px",
                    color: "#ff0000",
                  }}
                >

                  {!isAuthenticated && (
                    <>
                    {showDeactivateUserError ? (
                     <>
                      <p
                        className="ms-fontSize-12 login-form-error-messages ms-fontWeight"
                        style={{ marginBottom: "0px" }}
                      >
                        The account has been{" "}
                        <span className="ms-fontWeight-bold">
                          locked!
                        </span>
                      </p>
                      <p
                        className="ms-fontSize-12 login-form-error-messages ms-fontWeight"
                        style={{ marginTop: "0px" }}
                      >
                        {t("login.contact-administrator")}
                      </p>
                    </>
                    ) : 
                    <div
                        className="ms-fontSize-1"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          iconName="InfoSolid"
                          className="ms-fontSize-14"
                          style={{ marginRight: "5px" }}
                        ></Icon>
                        <p className="ms-fontSize-12 login-form-error-messages ms-fontWeight">
                          {errorMessage}
                        </p>
                      </div>}
                    </>
                  )}
                </div>
                <div>
                  <ATextField
                    name="username"
                    label="Username"
                    onChange={handleChange}
                    value={values.username}
                    onBlur={handleBlur}
                    errorMessage={touched.username && errors.username}
                    styles={textFieldStyles}
                    disabled={true}
                  />
                  <ATextField
                    name="otp"
                    label="OTP"
                    onChange={handleChange}
                    value={values.otp}
                    onBlur={handleBlur}
                    errorMessage={touched.otp && errors.otp}
                    styles={textFieldStyles}
                  />
                </div>
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <PrimaryButton
                    className="ms-fontSize-14"
                    text={t("authentication-2fa.login")}
                    style={{ width: "150px" }}
                    onClick={handleSubmit}
                  />
                  <PrimaryButton
                    className="ms-fontSize-14"
                    text={t("button.resend-otp")}
                    style={{ width: "150px" }}
                    onClick={handleResend}
                    disabled={!isResendEnabled}
                  />
                </div>
                {!isResendEnabled && !isUserLocked && (
                  <div
                    style={{
                      marginTop: "5px",
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <span style={{ fontSize: "13px" }}>
                      Resend OTP in {resendEnablingTime}s
                    </span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwoFAOtp;
